import { render, staticRenderFns } from "./ComponentHorasDoblesTriples.vue?vue&type=template&id=0f1bb03d&scoped=true"
import script from "./ComponentHorasDoblesTriples.vue?vue&type=script&lang=js"
export * from "./ComponentHorasDoblesTriples.vue?vue&type=script&lang=js"
import style0 from "./ComponentHorasDoblesTriples.vue?vue&type=style&index=0&id=0f1bb03d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1bb03d",
  null
  
)

export default component.exports